import { Link } from "react-router-dom";
import {
  CONTACT_EMAIL,
  EMR_SPECIALTY_LINKS,
  FOOTER_PRODUCT_LINKS,
  SOCIAL_LINKS,
} from "../../data/landingContent";
import BrandLogo from "./BrandLogo";

function SocialIcon({ label }) {
  if (label === "LinkedIn") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8.5h4V23h-4V8.5zM8.5 8.5h3.8v2h.05c.53-1 1.82-2.05 3.75-2.05 4 0 4.75 2.65 4.75 6.1V23h-4v-6.6c0-1.57-.03-3.6-2.2-3.6-2.2 0-2.54 1.72-2.54 3.5V23h-4V8.5z" />
      </svg>
    );
  }
  if (label === "Facebook") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2.5V12h2.5V9.7c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.5V12h2.8l-.5 2.9h-2.3v7A10 10 0 0022 12z" />
      </svg>
    );
  }
  if (label === "Instagram") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H7zm11 1.8a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zM12 7.5A4.5 4.5 0 1112 16.5 4.5 4.5 0 0112 7.5zm0 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5z" />
      </svg>
    );
  }
  return null;
}

export default function FooterDaa() {
  return (
    <footer>
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-col">
            <Link to="/" className="brand brand-with-logo">
              <BrandLogo variant="nav" />
              <span className="brand-text">Deepaarogya AI</span>
            </Link>
            <p className="footer-desc">
              The AI hospital OS for clinics and multi-specialty hospitals in India —
              EMR, OPD, IPD, pharmacy, billing, and clinical AI agents on one patient record.
            </p>
          </div>

          <div className="footer-col">
            <h4>EMR Specialties</h4>
            <ul>
              {EMR_SPECIALTY_LINKS.map((item) => (
                <li key={item.name}>
                  <Link to={item.path}>{item.name} EMR</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Products</h4>
            <ul>
              {FOOTER_PRODUCT_LINKS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.hash ? { pathname: item.path, hash: item.hash } : item.path}
                    className={item.highlight ? "footer-link-featured" : undefined}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li><Link to={{ pathname: "/", hash: "journey" }}>Patient Journey</Link></li>
              <li><Link to={{ pathname: "/", hash: "modules" }}>All Modules</Link></li>
              <li><Link to="/compare/healthplix">HealthPlix Alternative</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/security-abdm">Security &amp; ABDM</Link></li>
              <li><Link to={{ pathname: "/", hash: "faq" }}>FAQ</Link></li>
              <li>
                <a href="https://blog.deepaarogya.com/" target="_blank" rel="noopener noreferrer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Get started</h4>
            <ul>
              <li><Link to="/demo">Schedule a demo</Link></li>
              <li><Link to="/contact-us">Contact us</Link></li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Deepaarogya AI. All rights reserved.</span>
          {SOCIAL_LINKS.length > 0 ? (
            <div className="footer-social" aria-label="Social links">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                >
                  <SocialIcon label={s.label} />
                </a>
              ))}
            </div>
          ) : null}
          <span>Made in India</span>
        </div>
      </div>
    </footer>
  );
}
